
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../pages/chat/api";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../pages/chat/api";
let activeChatSocket = null;
let shouldStopStreaming = false;
export const fetchInvoiceChat = createAsyncThunk(
  "invoiceChat/fetchInvoiceChat",
  async ({ invoiceKey, clientMessage,chat_module = "document",type= "summary_request",}, { rejectWithValue, dispatch }) => {
    shouldStopStreaming = false;
    let token = await getFreshAccessToken();
    if (!token) {
      return rejectWithValue("No authorization token found");
    }
    const wsUrl = `wss://stagingbackend.docusensa.com/ws/rfp/chat/${invoiceKey}/?token=${token}`;

    // const wsUrl = `wss://stagingbackend.docusensa.com/ws/qdrant-chat-invoice/${invoiceKey}/?token=${token}`;
    
shouldStopStreaming = false;
if (activeChatSocket && activeChatSocket.readyState !== WebSocket.CLOSED) {
  activeChatSocket.close();
}
    const socket = new WebSocket(wsUrl);
activeChatSocket = socket;
    return new Promise((resolve, reject) => {
      let accumulatedAnswer = "";
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        socket.send(JSON.stringify({ message: clientMessage,chat_module: chat_module}));
        dispatch(updateStatus("loading"));
        dispatch(updatePartialAnswer(""));
      };

      socket.onmessage = (event) => {
          if (shouldStopStreaming) {
          console.warn("🛑 shouldStopStreaming is true → Closing WebSocket...");
          socket.close();
          dispatch(updateStatus("stopped")); // Optional UI update
          return;
        }
        
        try {
          const data = JSON.parse(event.data);

          if (
            data.type !== "info" &&
            data.status !== "connected" &&
            data.chunk
          ) {
            accumulatedAnswer += data.chunk;
            dispatch(updatePartialAnswer(accumulatedAnswer));
          }

          if (data.type === "final") {
              const sources = data.data.sources || []; 
            botMessageId = data.data.bot_message_id;
            runId = data.data.run_id;
            generatedQuestions = data.data.generated_questions;

            dispatch(updateFinalAnswer(accumulatedAnswer));
            dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions, sources  }));
            socket.close();
            resolve(accumulatedAnswer);
          }
        } catch (error) {
          console.error("Error parsing WebSocket message:", event.data, error);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
        reject(rejectWithValue("WebSocket connection error"));
      };

      socket.onclose = () => {
      };
    });
  }
);


export const fetchInvoiceSummary = createAsyncThunk(
  "invoiceChat/fetchInvoiceSummary",
  async ({ invoiceKey, clientMessage,chat_module = "document",type= "summary_request",}, { rejectWithValue, dispatch }) => {
    let token = await getFreshAccessToken();
    if (!token) {
      return rejectWithValue("No authorization token found");
    }
    const wsUrl = `wss://stagingbackend.docusensa.com/ws/rfp/chat/${invoiceKey}/?token=${token}`;

    // const wsUrl = `wss://stagingbackend.docusensa.com/ws/invoice-summary-and-chats/${invoiceKey}/?token=${token}`;

    const socket = new WebSocket(wsUrl);

    return new Promise((resolve, reject) => {
      let accumulatedAnswer = "";
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        socket.send(JSON.stringify({ message: clientMessage,chat_module: chat_module ,type: type}));
        dispatch(updateStatus("loading"));
        dispatch(updatePartialAnswer(""));
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (
            data.type !== "info" &&
            data.status !== "connected" &&
            data.message
          ) {
            accumulatedAnswer += data.message;
            dispatch(updatePartialAnswer(accumulatedAnswer));
          }

          if (data.pdf_details) {
            if (data.pdf_details.example_questions) {
                generatedQuestions = data.pdf_details.example_questions;
                dispatch(updateGeneratedQuestions(generatedQuestions)); 
                dispatch(updateSummaryStatus("succeeded"));

            }

            // Extract and combine user initials
            const firstChar = data.pdf_details.first_char || "";
            const lastChar = data.pdf_details.last_char || "";
            const userInitials = (firstChar + lastChar).trim().toUpperCase() || "N/A";

            dispatch(updateUserInitials(userInitials)); 
        }

          if (data.type === "final") {
            botMessageId = data.data.bot_message_id;
            runId = data.data.run_id;
            const summary = data.data.summary; // Add this
            let formattedTimestamp = "N/A";  // Default fallback

            if (data.data.summary_generated_at) {
              try {
                formattedTimestamp = new Date(data.data.summary_generated_at).toLocaleString("en-US", {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                });
              } catch (error) {
                console.error("Error parsing summary_generated_at:", error);
              }
            }
            
          
            // Extract user initials
            const firstChar = data.data.first_char || "";
            const lastChar = data.data.last_char || "";
            const userInitials = (firstChar + lastChar).trim().toUpperCase() || "N/A";
            
          
         
            dispatch(updateFinalSummary(summary));
            dispatch(setIsSummaryCompleted(true));
            generatedQuestions = data.data.example_questions || ""; 

            dispatch(updateSummaryMetadata({ formattedTimestamp, userInitials }));

            dispatch(updateGeneratedQuestions(generatedQuestions)); // Update the state with the summary
            dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions }));
            dispatch(updateStatus("succeeded"));
            socket.close();
            resolve(accumulatedAnswer);
        }
        
        } catch (error) {
          console.error("Error parsing WebSocket message:", event.data, error);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
        reject(rejectWithValue("WebSocket connection error"));
      };

      socket.onclose = () => {
      };
    });
  }
);






const invoiceChatSlice = createSlice({
  name: 'invoiceChat',
  initialState: {
    messages: [],
    partialAnswer: '',
    finalAnswer: '',
    status: 'idle',
    error: null,
    botMessageId: null,
    runId: null,
    generatedQuestions: null,
    feedback: {},
    formattedTimestamp: "",
    userInitials: "",
  },
  initialState: {
    messages: [],
    partialAnswer: '',
    finalAnswer: '',
    partialSummary: '',
    finalSummary: '',
    status: 'idle',
    summaryStatus: 'idle',
    error: null,
    summaryError: null,
    botMessageId: null,
    runId: null,
    generatedQuestions: null,
    feedback: {},
    formattedTimestamp: "",
    userInitials: "",
  },
  
  reducers: {
    resetInvoiceChatState: (state) => {
      state.messages = [];
      state.partialAnswer = '';
      state.finalAnswer = '';
      state.status = 'idle';
      state.error = null;
      state.botMessageId = null;
      state.runId = null;
      state.generatedQuestions = null;
      state.feedback = {};
    },
    updatePartialAnswer: (state, action) => {
      state.partialAnswer = action.payload;
    },
    
    updateFinalAnswer: (state, action) => {
      state.finalAnswer = action.payload;
    },
     updateBotMessageInfo: (state, action) => {
      const { botMessageId, runId, generatedQuestions, sources } = action.payload;
      state.botMessageId = botMessageId;
      state.runId = runId;
      state.generatedQuestions = generatedQuestions;
      state.sources = sources || [];
    },
    updateGeneratedQuestions: (state, action) => {
      state.generatedQuestions = action.payload; 
    },
    updateFeedback: (state, action) => {
      const { messageId, feedbackType } = action.payload;
      state.feedback[messageId] = feedbackType;
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
    },
    updatePartialSummary: (state, action) => {
      state.partialSummary = action.payload;
    },
    updateFinalSummary: (state, action) => {
      state.finalSummary = action.payload;
    },
    updateSummaryStatus: (state, action) => {
      state.summaryStatus = action.payload;
    },
    setIsSummaryCompleted: (state, action) => {
      state.isSummaryCompleted = action.payload;
    }
,    
    updateSummaryMetadata: (state, action) => {
    
      if (action.payload) {
        state.formattedTimestamp = action.payload.formattedTimestamp ? action.payload.formattedTimestamp : "N/A";
        state.userInitials = action.payload.userInitials ? action.payload.userInitials : "N/A";
      }
    },
    resetStopStreaming: (state) => {
        shouldStopStreaming = false;
      },
      stopStreaming: (state) => {
      shouldStopStreaming = true;
    }
    
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoiceChat.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchInvoiceChat.fulfilled, (state, action) => {
        state.messages.push(action.payload);
        state.status = 'succeeded';
      })
      .addCase(fetchInvoiceSummary.pending, (state) => {
        state.summaryStatus = 'loading';
      })
      .addCase(fetchInvoiceSummary.fulfilled, (state) => {
        state.summaryStatus = 'succeeded';
      })
      .addCase(fetchInvoiceSummary.rejected, (state, action) => {
        state.summaryError = action.payload;
        state.summaryStatus = 'failed';
      })
      .addCase(fetchInvoiceChat.rejected, (state, action) => {
        state.error = action.payload;
        state.status = 'failed';
      });
      
  },
});

export const {
  resetInvoiceChatState,
  updatePartialAnswer,
  updateFinalAnswer,
  updatePartialSummary,
  updateFinalSummary,
  updateSummaryStatus,
  updateBotMessageInfo,
  updateGeneratedQuestions,
  updateStatus,
  updateSummaryMetadata,
  updateUserInitials,
  setIsSummaryCompleted,
   stopStreaming,
  resetStopStreaming,
} = invoiceChatSlice.actions;


export default invoiceChatSlice.reducer;